import React from 'react';
import { RouteObject, Outlet } from 'react-router-dom';
import SignInSecurity from './SignInSecurity';
import Mfa from './Mfa';
import SignInActivity from './SignInActivity';
import withRoute from 'components/common/Route';

export const SignInSecurityLayout = () => <Outlet />;

const routes: RouteObject[] = [
  {
    path: '*',
    Component: () => withRoute(SignInSecurity),
  },
  {
    path: 'mfa',
    Component: () => withRoute(Mfa),
  },
  {
    path: 'activity',
    Component: () => withRoute(SignInActivity),
  },
];

export default routes;
